import { useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "@tanstack/react-router";
import { usePrivy } from "@privy-io/react-auth";
import { useStats } from "@/lib/hooks/useApi";

const FIRST_LOGIN_HOME_REDIRECT_KEY_PREFIX = "cfl:first-login-home-redirected";

export function RefCheck() {
  const { user } = usePrivy();
  const navigate = useNavigate();
  const location = useLocation();
  const walletAddress = user?.wallet?.address;
  const { data: statsData } = useStats(walletAddress ?? "");
  const homeRedirectKey = useMemo(() => {
    if (!walletAddress) return null;
    return `${FIRST_LOGIN_HOME_REDIRECT_KEY_PREFIX}:${walletAddress.toLowerCase()}`;
  }, [walletAddress]);
  const hasHomeRedirected =
    typeof window !== "undefined" && homeRedirectKey
      ? Boolean(window.localStorage.getItem(homeRedirectKey))
      : false;

  useEffect(() => {
    if (!statsData || !walletAddress) return;
    if (!hasHomeRedirected) return;

    // Check if this is the user's first session
    if (statsData.isFirstSession === true) {
      // Allow only /referrer route, redirect all other routes to /referrer
      if (location.pathname !== "/referrer") {
        // Redirect immediately to referrer page
        navigate({ to: "/referrer", replace: true });
      }
    }
  }, [
    hasHomeRedirected,
    statsData,
    navigate,
    location.pathname,
    walletAddress,
  ]);

  return <></>;
}
